<template>
    <v-dialog v-model="dialog" persistent width="500px">
        <v-card>
            <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm update</v-card-title>
            <br>
            <v-card-text>{{ getWarningText() }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="warning mx-2" small v-on:click="processWarning('yes')">Yes</v-btn>
                <v-btn color="success" small @click="processWarning('no')">No</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
   export default {
        data() {
            return {
                dialog: false,
                type: ''
            }
        },
        methods: {
            open(type) {
                this.dialog = true;
                this.type = type
            },
            processWarning(answer){
                this.$emit('processWarning', answer);
                this.dialog = false;
            },
            getWarningText(){
                if(this.type.toUpperCase()==='IMPORTEDBOOKING'){
                    return "You are updating an imported booking. No confirmation mails will be sent."
                }else {
                    return "After this update a confirmation mail will be send. To avoid 'spamming' you should make sure the update is complete. Are you sure the update is complete and do you want to save the update ?"
                }
            }
        }
    }
</script>

<style scoped>

</style>